import React from 'react';
import {Link, withRouter } from 'react-router-dom';
import noResultsImg from '../../images/no-results.png'

@withRouter
export default class NoResults extends React.Component{
    render(){
        return(
            <section className="no-results section-center">
                <div className="section-center-wrapper">
                    <h3 className="title">No matches for the result «{this.props.title}»</h3>
                    <img src={noResultsImg} alt="No results"/>
                    <p className="desc">Try another search request or browse all categories</p>
                    <div className="button-set">
                        <Link
                            to='/categories'
                            className="btn blue rounded">
                            All Categories
                        </Link>
                    </div>
                </div>
            </section>
        )
    }
}







// WEBPACK FOOTER //
// ./src/modules/blocks/noResults.js